module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_short_back.76c18c6f.png";